import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CRow,CCol,
	CForm,CFormInput,CFormSelect,CInputGroup,CInputGroupText,CFormCheck,CFormTextarea,
	CCard,CCardHeader,CCardBody,CCardFooter,
	CDropdown,CDropdownToggle,CDropdownMenu,CDropdownItem,CDropdownDivider,
	CImage,
	CLink,
	CTooltip,
	CBadge,
	CSpinner,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
//import NumberFormat from 'react-number-format';
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import { isMobile } from "react-device-detect";
import {
	MyPagination,
	MyDialogform,
} from '../components/index'
import { Konfirm } from '../helpers/onConfirm'
import { UFunc,cBulanPanjang } from '../helpers/functions'

const pjson 		= require('../../package.json')
const Lappasienbaru	= (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif
	} = props; 

	//--DOM--/
	const uNavigate 			= useNavigate();
	const uDispatch 			= useDispatch();
	//--END DOM--/

	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uSettinguserObj 			= useSelector(state => state.gListUserSetting);
	const uIsScrollBottom			= useSelector(state => state.gIsScrollBottom);
	const uEfekapp					= useSelector(state => state.effectApp);
	const uConfigappsObj			= useSelector(state => state.uConfigappsObj) || {}; 
	const uSystemsettingObj			= useSelector(state => state.gSystemsetting);
	const [uEfekview,setEfekview] 	= React.useState(false);
	const uMaxData					= isMobile ? (uSettinguserObj.jml_mobile || 25) : 100;
	const uKeywordObj				= JSON.parse(localStorage.getItem("listkeyword")) || {};
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const uISDemoapp				= uConfigappsObj.level_app === "DEMO";
	const uSelisihrangetanggal 		= useSelector(state => state.gSelisihrangetanggal);
	
	const uHeaderActionObj  = useSelector(state => state.gInitHeaderAction);
	const uHandelView 		= uHeaderActionObj.isHeaderView || false;
	const uHandelReset 		= uHeaderActionObj.isHeaderreset || false;

	//--VIEWS_VARS--/
	const [uHtml500msg,setHtml500msg]	= React.useState(); 
	const uIsHapusallow					= (uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN") ? true : false;
	const [uIsDataloaded,setDataloaded]	= React.useState(false); 
	const [uCaptionObj,setCaptionObj]	= React.useState({}); 
	const [uFilterObj,setFilterObj]		= React.useState({});
	const [uFirstload,setFirstload]		= React.useState("YA");
	const [uSortedObj,setSortedObj]		= React.useState({});

	const [uTimeelapse,setTimeelapse]	= React.useState(0); 
	const [uJmlData,setJmlData]			= React.useState(0);
	const [uPageActive,setPageActive]	= React.useState(1);
	const [uJmlHal,setJmlHal]			= React.useState(1);
	const [uRowselect,setRowselect]		= React.useState(-1);
	const [uDataselectID,setDataselectID]= React.useState(0);

	const uDatacabangArr				= JSON.parse(localStorage.getItem("cabanglist")||"[]")
	const [uDatadefaultArr,setDatadefaultArr]= React.useState([]);
	const [uDatamainArr,setDatamainArr]	= React.useState([]);
	const [uDatasumArr,setDatasumObj]	= React.useState({});
	const uCabangviewArr	= uTokenObj.userhak==="FREEROLE" ? uDatacabangArr
		: uDatacabangArr.filter(vItems=>(uTokenObj.user_cabangarr || []).includes(vItems.id.toString()))
	//--END VIEWS_VARS--/

	//--INIT_SELECTED_BEFORE--/
	const uLastinitObj 					= useSelector(state => state.gInitTabelSelected);// || {};
	const [uInitselectedObj,setInitselectedObj] = React.useState({});
	//--END INIT_SELECTED_BEFORE--*/

	//--DLGFORM--/
	const [uISDlgformshow,setDlgformshow]		= React.useState(false);
	const [uFormdataObj,setFormdataObj]			= React.useState({});
	//--END DLGFORM--/

	//--DLGVIEW--/
	//--END DLGVIEW--/

	//--DOM_VARS--/
	const uElJmlData					= document.getElementById("idjmldata");
	const [uElBtnsimpan,setElBtnsimpan]	= React.useState(document.getElementById("btnDialogSimpan"));
	const fileType 		= "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
	const fileExtension = ".xlsx";

	const uISTabletmode		= window.outerWidth > 425 && window.outerWidth <= 768
	const uISCellmode		= window.outerWidth <= 425;
	//--END DOM_VARS--/

	//--SETTING_CETAK--/
	const uHTMLstylelaporan		= useSelector(state => state.gHTMLstyleLaporan);
	const uFrameExport 			= document.getElementById("ifmcontentstoprint");
	//--END SETTING_CETAK--/

	//--HANDEL--/
	const hdlKlikDlgsimpan = () => {
		//--VALIDASI_FILTER--/
		let vElfocus	= document.getElementById("inpcabangid");
		if(parseInt(uFormdataObj.cabang_id||"0") <= 0) {
			vElfocus && vElfocus.focus();
			showToast("Cabang Harus Dipilih !");
			return
		}

		vElfocus		= document.getElementById("inpbulanid");
		if( (parseInt(uFormdataObj.bln)||0) <= 0 
			|| (parseInt(uFormdataObj.bln)||0) > 12 
			) {
			vElfocus && vElfocus.focus();
			showToast("Bulan Laporan Tidak Valid !"); return
		}
		//alert(vTanggalDT);return;
		//--END VALIDASI_FILTER--/

		setDataloaded(false);
		apiLoadview();
	}
	const hdlKlikSort = (_NAMAKOL) => {
		_NAMAKOL		= (_NAMAKOL||"").toUpperCase();
		const vNamenow	= (uSortedObj.nama||"").toUpperCase();
		const vSortnow	= (uSortedObj.jenis||"").toUpperCase();

		const vSortedObj		= uSortedObj;
		vSortedObj.init_aktif 	= "YA";
		if(vNamenow==="" || vNamenow !== _NAMAKOL) {
			vSortedObj.nama 	= _NAMAKOL.toLowerCase();
			vSortedObj.jenis 	= "ASCENDING";
		} else if(vNamenow===_NAMAKOL) {
			if(vSortnow==="ASCENDING")
				vSortedObj.jenis = "DESCENDING";
			else if(vSortnow==="DESCENDING") {
				 vSortedObj.nama 	= "";
				 vSortedObj.jenis 	= "";
			}
		}
		vSortedObj.init_aktif 	= undefined;

		setSortedObj(vSortedObj);
		setEfekview(!uEfekview);
	}
	const hdlKlikCetak = () => {
		if(uDatamainArr.length <= 0) return;

		const vContent 	= contentCetak();
		if(vContent === "") return
		//console.log("(Lapasuransi - hdlKlikCetak) vContent = "+vContent)

		var pri 		= uFrameExport.contentWindow;
		pri.document.open();
		pri.document.write(vContent);
		pri.document.close();
		pri.window.focus();
		pri.window.print();
	}
	const hdlKlikExcel = () => {
		if(uDatamainArr.length <= 0) return;

		contentExcel();
	}
	//--END HANDEL--/

	//--INIT--/
	const initResettampilan = () => {
		setCaptionObj({});
		setDatamainArr([]);
		setDataselectID(0); setRowselect(-1); setPageActive(1);
		setFilterObj({}); setSortedObj({});
	}
	const initJmldata = () => {
		uElJmlData 
			&& (uElJmlData.innerHTML = UFunc.formatAngka(uJmlData));
	}
	//--END INIT--/

	//--CONTENT_FUNC--/
	const contentLaporan = () => {
		if(!uIsDataloaded) return ""

		//console.log("(Lappasienbaru - contentLaporan) uFilterObj.asuransi_id => "+uFilterObj.asuransi_id);
		if(uJmlData <= 0) return (
			<div className="mx-md-5 px-lg-5">
			&middot;&middot; {uBahasaObj.caption_dataempty||"Data Tidak Ada"} &middot;&middot;
			</div>
		)//->

		const vMin 			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= (vMin);

		const vStylekolfixed = {
			position: "sticky",
			left: 0,
			background: "#f0f0f0",
			zIndex: 1,
			borderRight:"1px solid #DCDCDC",
		}
		const vWidthtabel	= 700;
		const vDataviewArr	= uDatamainArr.slice(vMin,vMax);
		
		return (
		<div style={{overflowX:"auto"}} id="iddivtabel">
		<table style={{minWidth:vWidthtabel,width:(uISTabletmode || uISCellmode) ?  "100%" : "70%"}}
			className="table table-borderless table-striped table-hover mx-auto" 
			id="idtabeldata">
		<thead>
			<tr className="d-none"><th colSpan={5}>{vMin} - {vMax}</th></tr>
			<tr className="text-center align-top classfontsmaller">
			<th width={40} className="px-1 border" style={vStylekolfixed}><small>No</small></th>
			<th className="px-1 text-start border" width={250} style={{...vStylekolfixed,left:40}}>
				<small>{uBahasaObj.caption_tglkunjungan||"Tgl Kunjungan"}</small>
			</th>
			<th className="px-1 border">
				<small>{uBahasaObj.caption_jmlkunjungan||"Jml Kunjungan"}</small>
			</th>
			<th width="7%" style={{minWidth:150}} className="px-1 border"><small>Pasien BARU</small></th>
			<th width="7%" style={{minWidth:150}} className="px-1 border"><small>Pasien Lama</small></th>
			</tr>
		</thead>

		<tbody>
		{vDataviewArr.map((vItems,vKeys) => {
			const {
				jml_kunjungan,jml_baru,jml_lama,tgl_kunjungan,
				id
			} = vItems;

			vNumber++;

			return (
			<tr className={"align-top text-end"+(uRowselect===vKeys?" classrowselect":"")}
				 id={"idtr"+id}
				 key={vKeys}>
				<td className="px-1 text-end" style={vStylekolfixed}>{vNumber}.</td>
				<td className="px-1 text-start" style={{...vStylekolfixed,left:40}}>
					{UFunc.TglAngka(tgl_kunjungan)}
				</td>
				
				<td className="px-1 text-center">{UFunc.formatAngka(jml_kunjungan)}</td>
				
				<td className="px-1 text-center">{UFunc.formatAngka(jml_baru)}</td>
				<td className="px-1 text-center">{UFunc.formatAngka(jml_lama)}</td>
			</tr>
			)
		})}
		</tbody>

		<tfoot className="fw-bolder bg-primary text-white">
			<tr>
			<td colSpan={2} className="text-center text-capitalize bg-primary text-white" style={vStylekolfixed}>{uBahasaObj.word_jumlah||"Jumlah"}</td>
			<td className="px-1 text-center">{UFunc.formatAngka(uDatasumArr.jml_kunjungan)}</td>
			<td className="px-1 text-center">{UFunc.formatAngka(uDatasumArr.jml_baru)}</td>
			<td className="px-1 text-center">{UFunc.formatAngka(uDatasumArr.jml_lama)}</td>
			</tr>
		</tfoot>
		</table>
		</div>
		)//>
	}
	const contentDlgform = () => {
		if(!uISDlgformshow) return (<></>)//->

		const vJmlTahunlaporan	= parseInt(uSystemsettingObj.jml_tahun_laporan)||5;
		const vTahunnow			= (new Date()).getFullYear();

		return (
		<CForm>
		{uDatacabangArr.length > 1 && (
		<CRow className="my-2">
		<CCol xs="3" md="4">Cabang</CCol>
		<CCol className="text-end">
			<CFormSelect size="sm"
				value={uFormdataObj.cabang_id||0}
				onChange={(e)=>setFormdataObj({...uFormdataObj,cabang_id: e.target.value})}
			id="inpcabangid">
			{uCabangviewArr.map((vItems,vKeys)=>{
				const {
					id,cabang_nama
				} = vItems

				return (
				<option value={id} key={vKeys}>{(cabang_nama||"UNDF").toUpperCase()}</option>
				)
			})}
			</CFormSelect>
		</CCol>
		</CRow>
		)}

		<CRow className="my-2">
		<CCol xs="3" md="4">Bulan</CCol>
		<CCol className="text-end">
			<CInputGroup size="sm">
			{1===3 && (
			<>
			<CFormInput size="sm" type="date"
				style={{width:"auto"}}
				value={uFormdataObj.tgl_awal}
				onChange={(e)=>setFormdataObj({...uFormdataObj,tgl_awal: e.target.value})}
				id="inptglawal"/>
			<CInputGroupText>s.d.</CInputGroupText>
			<CFormInput size="sm" type="date"
				value={uFormdataObj.tgl_akhir}
				onChange={(e)=>setFormdataObj({...uFormdataObj,tgl_akhir: e.target.value})}
				onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
				id="inptglakhir"/>
			</>
			)}

			<CFormSelect size="sm"
				style={{width:"auto"}}
				value={uFormdataObj.bln||((new Date()).getMonth()+1)}
				onChange={(e)=>setFormdataObj({...uFormdataObj,bln: e.target.value})}
			id="inpbulanid">
				{cBulanPanjang.map((vItems,vKeys)=>{
					return (
					<option key={vKeys} value={vKeys+1} className="text-uppercase">
					{vItems.toUpperCase()}
					</option>
					)//>
				})}
			</CFormSelect>
			&nbsp;
			<CFormSelect size="sm"
				style={{width:"auto"}}
				value={uFormdataObj.thn || UFunc.leadZero((new Date()).getFullYear())}
				onChange={(e)=>{uFormdataObj.thn = e.target.value; setEfekview(!uEfekview)}}
				id="inpbulantahun">
				{[...new Array(vJmlTahunlaporan)].map((vItems,vKeys)=>{
					return (
					<option value={(vTahunnow - vKeys)} key={vKeys}>{(vTahunnow - vKeys)}</option>
					)
				})}
			</CFormSelect>
			</CInputGroup>
		</CCol>
		</CRow>
		</CForm>
		)
	}
	const contentCetak = () => {
		if(uDatamainArr.length <= 0) return "";
		//console.log("(Lapasuransi - contentCetak) vHTMLs => "+vHTMLs)

		const vCabangIdx	= UFunc.getObjectIndeks(uDatacabangArr,uFilterObj.cabang_id);
		const vCabangtext	= vCabangIdx>=0 ? uDatacabangArr[vCabangIdx].cabang_nama : "UNDF";

		const vDatasourceArr= uDatamainArr;
		const vColspan		= 5;

		let vHTMLs 	= uHTMLstylelaporan;
		vHTMLs += `
			<table id="idtabelhtml">
			<thead>
			<tr>
			<td colspan="`+vColspan+`">
			<div><b>`+(uBahasaObj["menus_"+uActiveroute.toLowerCase()]||"Laporan").toUpperCase()+`</b></div>
			<div>`+uCaptionObj.title+`</div>`+
			(uDatacabangArr.length > 1 
				? (`<div>Cabang: `+vCabangtext+`</div>`) 
				: ``)+`
			</td>
			</tr>
			<tr class="idtabelheader" valign="top">
				<th width="7%">No</th>
				<th align="left">`+(uBahasaObj.word_tanggal||"Tanggal")+`</th>
				<th width="20%">`+(uBahasaObj.caption_jmlkunjungan||"Jml Kunjungan")+`</th>
				<th width="20%">Baru</th>
				<th width="20%">Lama</th>
			</tr>
			</thead>
			<tbody>`;

		vHTMLs	+= vDatasourceArr.map((vItems,vKeys)=>{
			const {
				jml_kunjungan, jml_lama, jml_baru, tgl_kunjungan,
				id
			} = vItems;

			return (`
				<tr key={vKeys} valign="top">
					<td align="right" style="">`+(vKeys+1)+`.</td>
					<td align="left">`+UFunc.TglAngka(tgl_kunjungan)+`</td>
					<td align="center">`+UFunc.formatAngka(jml_kunjungan)+`</td>
					<td align="center">`+UFunc.formatAngka(jml_baru)+`</td>
					<td align="center">`+UFunc.formatAngka(jml_lama)+`</td>
				</tr>
			`);
		}).join(``);

		vHTMLs += `
			</tbody>
			<tfoot>
			<tr>
			<td colspan="2" align="center">Jumlah</td>
			<td align="center">`+UFunc.formatAngka(uDatasumArr.jml_kunjungan)+`</td>
			<td align="center">`+UFunc.formatAngka(uDatasumArr.jml_baru)+`</td>
			<td align="center">`+UFunc.formatAngka(uDatasumArr.jml_lama)+`</td>
			</tr>
			</tfoot>
			</table>
		`;
		return vHTMLs;	
	}
	const contentExcel = () => {
		const vCabangIdx	= UFunc.getObjectIndeks(uDatacabangArr,uFilterObj.cabang_id);
		const vCabangtext	= vCabangIdx>=0 ? uDatacabangArr[vCabangIdx].cabang_nama : "UNDF";

		const vColspan		= 5;

		let vDatasetsArr 	= [];
		let vRowcount		= 0;
		let vColposwidth	= 50;

		let vTmpObj	= {
			no : "",
			tgl_kunjungan: "",
			jml_kunjungan: "",
			jml_baru: "",
			jml_lama: "",
		};
		vDatasetsArr.push(vTmpObj);
		vRowcount++;
		
		uDatamainArr.map((vItems,vKeys)=>{
			const {
				jml_kunjungan, jml_lama, jml_baru, tgl_kunjungan,
				id
			} = vItems;


			vTmpObj	= {
				no : {v:vKeys+1,t:"n"},
				tgl_kunjungan: { v:UFunc.toDate(tgl_kunjungan), t:"d", s:{alignment:{horizontal:"left"}} },
				jml_kunjungan: { v:(parseInt(jml_kunjungan)||0), t:"n", s:{alignment:{horizontal:"center"},numFmt: "#,##0"} },
				jml_baru: { v:(parseInt(jml_baru)||0), t:"n", s:{alignment:{horizontal:"center"},numFmt: "#,##0"} },
				jml_lama: { v:(parseInt(jml_lama)||0), t:"n", s:{alignment:{horizontal:"center"},numFmt: "#,##0"} },
			}
			vDatasetsArr.push(vTmpObj);
			vRowcount++;
		});

		//--SUM_NILAI--/
		vTmpObj	= {
			no : {v: "Jumlah",t:"s",s:{alignment:{horizontal:"center"},font:{bold:true} }},
			tgl_kunjungan: "",
			jml_kunjungan: { v:parseInt(uDatasumArr.jml_kunjungan||"0"), t:"n", s:{alignment:{horizontal:"center"},numFmt: "#,##0"} },
			jml_baru: { v:parseInt(uDatasumArr.jml_baru||"0"), t:"n", s:{alignment:{horizontal:"center"},numFmt: "#,##0"} },
			jml_lama: { v:parseInt(uDatasumArr.jml_lama||"0"), t:"n", s:{alignment:{horizontal:"center"},numFmt: "#,##0"} },
		};
		vDatasetsArr.push(vTmpObj);
		vRowcount++;
		//--END SUM_NILAI--/

		const wsrows	= [{hpt:48},{hpt:25}]
		const wscols	= [
			{wpx:40},
			{wpx:150},
			{wpx:100},
			{wpx:100},
			{wpx:100},
		];
		
		const wsmerge	= [
			{s:{r:0,c:0},e:{r:0,c:vColspan - 1}},
			{s:{r:vRowcount,c:0},e:{r:vRowcount,c:vColspan - 1 - 3}}
		]

		const vTanggalnowDT	= new Date()
		const vNamafile 	= 
			vTanggalnowDT.getFullYear()+
			UFunc.leadZero(vTanggalnowDT.getMonth()+1)+
			UFunc.leadZero(vTanggalnowDT.getDate())+"_LAPPASIENBARU_"+
			uFilterObj.thn+UFunc.leadZero(uFilterObj.bln)+
		"";
		const vSheetlabel = 
			uFilterObj.thn+UFunc.leadZero(uFilterObj.bln)+
		"";

		const ws 		= XLSX.utils.json_to_sheet(vDatasetsArr);

		//--CUSTOM_HEADER--/
		const vJudullaporan = uBahasaObj["menus_"+(uActiveroute||"").toLowerCase()]+
			"\r\nPeriode "+cBulanPanjang[uFilterObj.bln-1]+" "+
			(uFilterObj.thn)+
			(uDatacabangArr.length > 1 ? "\r\nCabang: "+vCabangtext : "" )+
		"";
		const vHeaderArr = [
			{v:"No",s:{alignment:{horizontal:"center",wrapText: true,vertical:"top"},font:{bold:true}}}, 
			{v:"Tgl Kunjungan",s:{alignment:{horizontal:"left",wrapText: true,vertical:"top"},font:{bold:true}}}, 
			{v:"Jml Kunjungan",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"Baru",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
			{v:"Lama",s:{alignment:{horizontal:"center",vertical:"top",wrapText: true},font:{bold:true}}}, 
		];

		XLSX.utils.sheet_add_aoa(ws, [[{v:vJudullaporan,t:"s",s:{
			alignment:{horizontal:"center",vertical:"center",wrapText: true},
			font:{bold:true} 
		}}]], { origin: "A1" });
		XLSX.utils.sheet_add_aoa(ws, [vHeaderArr], { origin: "A2" });
		//--END CUSTOM_HEADER--*/

		ws['!rows'] 	= wsrows;
		ws['!cols'] 	= wscols;
		ws["!merges"] 	= wsmerge;

		const wb 		= { Sheets: { [vSheetlabel]: ws }, SheetNames: [vSheetlabel] };
		const excelBuffer = XLSX.write(wb, { bookType: "xlsx", bookSST: true, type: "array" });
		const data 		= new Blob([excelBuffer], { type: fileType });
		FileSaver.saveAs(data, vNamafile + fileExtension);
	}
	//--END CONTENT_FUNC--/

	//--API--/
	const apiLoadawal = () => {}
	const apiLoadview = () => {
		const vTmpFilterObj 		= uFormdataObj;
		vTmpFilterObj.init_change 	= undefined;
		uElBtnsimpan && (uElBtnsimpan.disabled = true)
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		let vTmpObj	= []
		let vTimeout = setTimeout(()=>{
			uElBtnsimpan && (uElBtnsimpan.disabled = false)
			clearTimeout(vTimeout)
			setLoading(false);
		},2500); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_filterlist : JSON.stringify(vTmpFilterObj),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_lappasienbaru/ld_laporan";

		setTimeelapse(0);
		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) {setSessionaktif(false); return response.json();} })
		.then((output_string) => {
			setSessionaktif(true);
			uElBtnsimpan && (uElBtnsimpan.disabled = false)
			setLoading(false);
			if(output_string.tampil) {
				setFilterObj(vTmpFilterObj);
				const vLoadArr	= JSON.parse(output_string.dataobject||"[]");
				//--LOAD_ALL_VIEW_PER_PAGE--/
				setDatamainArr(vLoadArr);
				//--END LOAD_ALL_VIEW_PER_PAGE--*/

				setFirstload("TIDAK");
				
				setDlgformshow(false);
				setDataloaded(true);

				const vTimeEnd = new Date();
				const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
				setTimeelapse(vTimeDiff);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Lappasienbaru - apiLoadview) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			uElBtnsimpan && (uElBtnsimpan.disabled = false)
			setLoading(false);
			console.log("(Lappasienbaru - apiLoadview) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	//--END API--/

	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
		uDispatch({type: "set", gUrlbefore: window.location.pathname + window.location.search});
		
		apiLoadawal();

		return () => {
			uDispatch({type: "set", gInitHeaderAction: {}});

			setDlgformshow(false); 
			setDatamainArr([]);
			setDataloaded(false)
		}
	},[])
	React.useEffect(()=>{
		if(uDatamainArr.length <= 0)
			{ setDatadefaultArr([]); return }

		//console.log("(Lappasienbaru - [uDatamainArr]) uDatamainArr => "+JSON.stringify(uDatamainArr));
		const vDatasourceArr= uDatamainArr;
		setDatadefaultArr([{init_change:"1"},...vDatasourceArr]) 
	},[uDatamainArr])
	React.useEffect(()=>{
		const vDatasourceArr= [...uDatamainArr];

		//console.log("(Lappasienbaru - [vDatasourceArr.length]) vDatasourceArr => "+JSON.stringify(vDatasourceArr) );
		setJmlData(vDatasourceArr.length);
		if(vDatasourceArr.length <= 0)
			{ setDatasumObj({}); return }

		const vJmlKunjungan	= vDatasourceArr.reduce((vStores,vItems) => 
			vStores + (parseInt(vItems.jml_kunjungan)||0)
			, 0);
		const vJmlLama	= vDatasourceArr.reduce((vStores,vItems) => 
			vStores + (parseInt(vItems.jml_lama)||0)
			, 0);
		const vJmlBaru	= vDatasourceArr.reduce((vStores,vItems) => 
			vStores + (parseInt(vItems.jml_baru)||0)
			, 0);

		setDatasumObj({
			jml_lama: vJmlLama,
			jml_baru: vJmlBaru,
			jml_kunjungan: vJmlKunjungan,
		});
	},[uDatamainArr,uDatamainArr.length])
	React.useEffect(()=>{ initJmldata() },[uElJmlData])
	React.useEffect(()=>{
		let vJmlHal	= Math.ceil(uJmlData / uMaxData);
		setJmlHal(vJmlHal);//-*/
		setPageActive(uPageActive<=0?1:uPageActive);

		initJmldata()
	},[uJmlData])
	React.useEffect(()=>{
		//--LOAD_ALL_VIEW_PER_PAGE--/
		//setDataselectID(0);
		setRowselect(-1);
		//--END LOAD_ALL_VIEW_PER_PAGE--/
	},[uPageActive])//-->Unselect_ROW
	React.useEffect(()=>{
		if(!uHandelView) return;

		uHeaderActionObj.isHeaderView = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		if(uHtml500msg) return;

		const vCabangID = localStorage.getItem("lastcabangid") || 
			(uDatacabangArr[0].id || "0");

		const vTanggalnowDT	= new Date();
		const vHeader 		= "Pilih Filter Laporan";

		setFormdataObj({
			cabang_id: uFilterObj.cabang_id || vCabangID,
			bln: uFilterObj.bln || vTanggalnowDT.getMonth()+1,
			thn: uFilterObj.thn || vTanggalnowDT.getFullYear(),
			init_change: 1,
			dlg_header: vHeader,
		});

		setDlgformshow(true)
	},[uHandelView])
	React.useEffect(()=>{
		if(!uHandelReset) return;

		uHeaderActionObj.isHeaderreset = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		if(uHtml500msg) { apiLoadawal(); }
		else { setDataloaded(false); }
	},[uHandelReset])
	React.useEffect(()=>{
		if(!uIsDataloaded)
			{ initResettampilan(); return; }

		//--SET_TITLE--/
		let vTitelmain	= "Periode ";
		vTitelmain += "<b>"+cBulanPanjang[uFormdataObj.bln-1]+" "+(uFormdataObj.thn)+"</b>";

		const vCabangIdx= UFunc.getObjectIndeks(uDatacabangArr,uFormdataObj.cabang_id);
		let vTitelsub	= uDatacabangArr.length > 1 ? (uDatacabangArr[vCabangIdx]||{}).cabang_nama+"" : "";

		setCaptionObj({title:vTitelmain,title_sub:vTitelsub});
		//--END SET_TITLE--/
	},[uIsDataloaded])
	React.useEffect(()=>{
		//console.log("(Lappasienbaru - [uISDlgformshow]) uFilterObj => "+JSON.stringify(uFilterObj));
		if(!uISDlgformshow) 
			{ setFormdataObj({}); return }

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			const vButton = document.getElementById("btnDialogSimpan");
			vButton && (vButton.innerHTML = "Tampilkan");
			setElBtnsimpan(vButton);
			
			let vElfocus = document.getElementById("inpcabangid");
			if(!vElfocus)
				vElfocus = document.getElementById("inptglawal");

			if(!isMobile)
				vElfocus && vElfocus.focus();
		},350)
	},[uISDlgformshow])
	React.useEffect(()=>{
		if(uDatamainArr.length <= 0) return;
		if(uPageActive > 1) setPageActive(1);
		else 
			{ setRowselect(-1); }

		if(JSON.stringify(uSortedObj||{}) === "{}") { return; }

		let vSortedArr;
		const vNamasort = (uSortedObj.nama||"").toLowerCase();
		const vISNumeric= UFunc.isNumeric(uDatamainArr[0][vNamasort]);
		if(uSortedObj.jenis === "ASCENDING") {
			vSortedArr	= !vISNumeric
				? uDatamainArr.sort((a, b) => {
					return (a[vNamasort] > b[vNamasort]) ? 1 : ((b[vNamasort] > a[vNamasort]) ? -1 : 0) 
					}) 
				: uDatamainArr.sort((a, b) => a[vNamasort] - b[vNamasort]) ;
		}else if(uSortedObj.jenis === "DESCENDING") {
			vSortedArr	= !vISNumeric
				? uDatamainArr.sort((a, b) => {
					return (b[vNamasort] > a[vNamasort]) ? 1 : ((a[vNamasort] > b[vNamasort]) ? -1 : 0) 
				})
				: uDatamainArr.sort((a, b) => b[vNamasort] - a[vNamasort]);
		} else {
			vSortedArr	= uDatadefaultArr.slice(1);//.splice(0,1);
		}
		setDatamainArr(vSortedArr);
		setEfekview(!uEfekview);
	},[uSortedObj,
	uSortedObj.nama,
	uSortedObj.jenis,
	])

	if(UFunc.isEmpty(uTokenObj)) { prosesExpired(); return ""; }
	if(uHtml500msg)  return (
		<CCard className="classbgcard">
		<CCardHeader>
		<strong>{uBahasaObj.caption_page500||"Page 500"}</strong>
		</CCardHeader>
		<CCardBody>{UFunc.renderHTML(uHtml500msg)}</CCardBody>
		</CCard>
	)

	return (
		<>
		{(!uIsDataloaded) ? (
		<CCard className="classbgcard">
			<CCardHeader className="fw-bolder">Pilih Filter Laporan</CCardHeader>
			<CCardBody className="mx-lg-5 p-lg-5">
			<div className="mx-md-5 p-md-5 fst-italic classpetunjuk">
			*) Silahkan Pilih Filter, untuk menentukan Parameter Laporan yang akan Ditampilkan. Kemudian Tekan SIMPAN. Untuk Mencetak Silahkan KLIK Ikon Cetak..
			</div>
			</CCardBody>
		</CCard>
		) : (
		<CCard className="classbgcard">
		<CCardHeader className="d-flex justify-content-between px-1 px-md-3">
		<div>
			<div className="d-none d-md-block">{UFunc.renderHTML(uCaptionObj.title)}</div>
			<div className="d-md-none classfontsmaller"><small>{UFunc.renderHTML(uCaptionObj.title)}</small></div>
			<span className="classfontsmaller text-primary">
				<small>
				{UFunc.renderHTML(uCaptionObj.title_sub)}
				</small>
			</span>
		</div>

		<div>
			<span className="d-none d-md-inline-block">
				<CTooltip content="--CETAK..">
				<CLink 
					className="classikon classikoncetak classcursorpointer"
					onClick={()=>hdlKlikCetak()}/>
				</CTooltip>

				<CTooltip content="--Export-2-Excel..">
				<CLink 
					className="classikon classikonexcel classcursorpointer"
					onClick={()=>hdlKlikExcel()}/>
				</CTooltip>
				
				<span className="mx-1">&middot;</span>
			</span>

			<span className="text-muted classfontsmaller">
				<small>{UFunc.formatAngka(uTimeelapse)} ms</small>
			</span>
			<span className="ms-1 d-md-none">&middot;</span>

			<CDropdown className="d-md-none">
				<CDropdownToggle caret={false} size="sm"
					className="p-0" color="transparent">
					<CIcon icon="cilChevronBottom" className="classikonbox mx-1" height={25}/>
				</CDropdownToggle>
				<CDropdownMenu>
					<CDropdownItem onClick={()=>hdlKlikCetak()}>
						<CIcon className="classikoncetak ms-0 me-2 align-middle" height={25}/>
						Cetak Laporan
					</CDropdownItem>
					<CDropdownItem onClick={()=>hdlKlikExcel()}>
						<CIcon className="classikonexcel ms-0 me-2 align-middle" height={25}/>
						Export-2-Excel
					</CDropdownItem>
				</CDropdownMenu>
			</CDropdown>
		</div>
		</CCardHeader>
		
		<CCardBody className="px-0">{contentLaporan()}</CCardBody>

		{(uJmlData > uMaxData) && (
			<CCardFooter>
			<MyPagination 
				activePage={uPageActive}
				pages={uJmlHal}
				onActivePageChange={(i)=>setPageActive(i)}
				align="start"/>
			</CCardFooter>
		)}
		</CCard>
		)}

		<MyDialogform
			options={{centered:true}}
			onSimpan={()=>hdlKlikDlgsimpan()}
			show={uISDlgformshow} 
			dialogHeader={uFormdataObj.dlg_header || ""}
			toggle={()=>setDlgformshow(false)}
			renderContent={contentDlgform()}/>

		<iframe id="ifmcontentstoprint" className="d-none"/>
		<div className="d-none">
			{(uSystemsettingObj.url_image_nota||"")!=="" && (
				<img src={uSystemsettingObj.url_image_nota} height="100"/>
			)}
		</div>
		</>
	)//>
}	

export default Lappasienbaru